module.exports = __webpack_public_path__ + "img/1970East-015_WEB-min.c9641da7.jpg";